import React from "react";
import { AuthContext } from "../components/AuthProvider/AuthProvider";
export function useAuth() {
  return React.useContext(AuthContext);
}
